// import { Plus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useDebounce } from 'use-debounce';
// import { formatDateIST, NotFoundImage } from '../../utils/function';
// import { ActionButton } from '../common/ActionButton';
import { PageHeader } from '../common/PageHeader';
import { SearchAndFilter } from '../common/SearchAndFilter';
import ConfirmModal from '../model/ConfirmModal';
// import Modal from '../model/Modal';
// import { CrudActions } from '../ui/action-menu';
// import { Badge } from '../ui/badge';
import { CustomPagination } from '../ui/CustomPagination';
import { ShowsTableSkeleton } from '../ui/skeleton';
import apiClient from '../../api/client';
import { Trash2 } from 'lucide-react';
// import { cn } from '../ui/utils';
// import ShowDetails from './ShowDetails';
// import { ShowForm } from './ShowForm';
// import { CategoryDisplay } from '../common/CategorySelector';

export interface Newletter{
  id: string;
  email: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;
}

export default function NewsLetter() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
    const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'inactive' | undefined>(
        (searchParams.get('status') as 'all' | 'active' | 'inactive') || 'all'
    );
    const page = Number(searchParams.get('page') ?? 1);
    const limit = Number(searchParams.get('limit') ?? 10);

    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 1
    });

    const [newsletters, setNewsletters] = useState<Newletter[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [currentShow, setCurrentShow] = useState<Show | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showToDelete, setShowToDelete] = useState<string | null>(null);

    const handleItemsPerPageChange = (newLimit: number) => {
        updateSearchParams({
            limit: newLimit,
            page: 1
        });
        fetchShows(1, searchTerm, newLimit);
    };

    const fetchShows = async (page: number, search = '', limit: number) => {
        try {
            setIsLoading(true);
            const {data} = await apiClient.get(`/admin/all-news-letter`, {params : {page, limit, search}})

            if (data?.success) {
                setNewsletters(data?.newsLetters);
                setPagination({
                    total: data?.pagination.total,
                    totalPages: data?.pagination.totalPages
                });
            } else {
                setNewsletters([]);
                setPagination({
                    total: 0,
                    totalPages: 1
                });
            }
        } catch (error) {
            console.error('Error fetching newsLetters:', error);
            toast.error('Failed to fetch newsLetters');
        } finally {
            setIsLoading(false);
        }
    };

    const [debouncedSearchTerm] = useDebounce(searchTerm, 500);

    const updateSearchParams = (params: {
        search?: string;
        limit?: number;
        status?: string;
        page?: number;
    }) => {
        const newParams = new URLSearchParams(searchParams);

        Object.entries(params).forEach(([key, value]) => {
            if (value === undefined || value === '' || value === 'all') {
                newParams.delete(key);
            } else {
                newParams.set(key, String(value));
            }
        });

        setSearchParams(newParams);
    };

    // const handleStatusChange = (value: 'all' | 'active' | 'inactive') => {
    //     setStatusFilter(value);
    //     updateSearchParams({
    //         status: value,
    //         page: 1
    //     });
    // };

    useEffect(() => {
        updateSearchParams({
            search: debouncedSearchTerm,
            status: statusFilter,
            page: 1,
            limit
        });
        setStatusFilter(undefined)
        fetchShows(1, debouncedSearchTerm, limit);
    }, [debouncedSearchTerm, limit, statusFilter]);
    //     setCurrentShow(show);
    // };

    // const handleEdit = (show: Show) => {
    //     setCurrentShow(show);
    //     setIsModalOpen(true);
    // };

    const handleDeleteClick = (id: string) => {
        setShowToDelete(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!showToDelete) return;

        try {
            const {data} = await apiClient.patch(`/admin/remove-newsletter/${showToDelete}`);
            if(data?.success){
                toast.success(data?.message)
                fetchShows(page, searchTerm, limit);
            }
        } catch (error) {
            console.error('Error removing newsletter:', error);
            toast.error('Failed to remove newsletter subscriber');
        } finally {
            setShowDeleteModal(false);
            setShowToDelete(null);
        }
    };

    // const toggleStatus = async (id: string, currentStatus: boolean) => {
    //     try {
    //         const response = await showsApi.updateShowStatus(id, { isActive: !currentStatus });
    //         if (response.success) {
    //             if (statusFilter !== 'all') {
    //                 setIsLoading(false)
    //                 await fetchShows(page, searchTerm, limit, statusFilter);
    //             } else {
    //                 setNewsletters(prevShows =>
    //                     prevShows.map(show =>
    //                         show.id === id ? { ...show, isActive: !currentStatus } : show
    //                     )
    //                 );
    //             }
    //             toast.success(response.message);
    //         } else {
    //             toast.error(response.message);
    //         }
    //     } catch (error) {
    //         console.error('Error toggling show status:', error);
    //         toast.error('Failed to update show status');
    //     }
    // };

    // const resetForm = () => {
    //     setCurrentShow(null);
    // };

    const handlePageChange = (newPage: number) => {
        if (newPage !== page) {
            updateSearchParams({ page: newPage, limit });
            fetchShows(newPage, searchTerm, limit);
        }
    };


    // const onSuccess = (newShow: Show) => {
    //     setIsModalOpen(false);
    //     resetForm();

    //     if (!currentShow) {
    //         setNewsletters(prev => [newShow, ...prev]);
    //     } else {
    //         setNewsletters(prev =>
    //             prev.map(show =>
    //                 show.id === newShow.id ? newShow : show
    //             )
    //         );
    //     }
    // };

    // const handleCloseViewModal = () => {
    //     setCurrentShow(null);
    // };

    return (
        <div className="space-y-6">
            <PageHeader
                title="Newsletter Subscribers"
                description="Manage newsletter subscribers"
                // action={
                //     <ActionButton
                //         onClick={handleAddShow}
                //         icon={<Plus className="w-4 h-4" />}
                //     >
                //         Add New Show
                //     </ActionButton>
                // }
            />

            <SearchAndFilter
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                onClearSearch={() => setSearchTerm('')}
                statusFilter={statusFilter}
                // onStatusChange={handleStatusChange}
                // filterOptions={[
                //     { value: "all", label: "All Subscription" },
                //     { value: "true", label: "Active" },
                //     { value: "false", label: "Inactive" },
                // ]}
                filterOptions={[]}
                searchPlaceholder="Search subscriptions by email..."
            />

            <div className="bg-[#0B1623] border border-white/10 rounded-2xl">
                <div className="overflow-x-auto custom-scrollbar">
                    <table className="w-full">
                        <thead className="bg-white/5 border-b border-white/10">
                            <tr>
                                {/* <th className="px-6 py-4 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">Id</th> */}
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">Email</th>
                                {/* <th className="px-6 py-4 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">Status</th> */}
                                <th className="px-6 py-4 text-right text-xs font-medium text-slate-400 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/5">
                            {isLoading ? (
                                <ShowsTableSkeleton />
                            ) : newsletters.length > 0 ? (
                                newsletters.map((newsletter) => (
                                    <tr key={newsletter.id} className="hover:bg-white/2 transition-colors group">
                                        {/* <td className="px-6 py-4">
                                            {newsletter.id}
                                        </td> */}
                                        <td className="px-6 py-4 text-sm text-slate-300">
                                            {newsletter.email}
                                        </td>
                                        {/* <td className="px-6 py-4">
                                            <Badge
                                                variant="outline"
                                                className={cn(
                                                    "rounded-full text-xs font-medium cursor-pointer",
                                                    newsletter.isActive
                                                        ? 'bg-green-500/20 text-green-400 border-green-500/30 hover:bg-green-500/30'
                                                        : 'bg-red-500/20 text-red-400 border-red-500/30 hover:bg-red-500/30'
                                                )}
                                                onClick={() => toggleStatus(newsletter.id, newsletter.isActive)}
                                            >
                                                {newsletter.isActive ? 'Active' : 'Inactive'}
                                            </Badge>
                                        </td> */}
                                        <td className="px-6 py-4 w-40 text-right">
                                            {/* <CrudActions
                                                onDelete={() => handleDeleteClick(newsletter.id)}
                                            /> */}
                                            {/* <button
                                                className='flex gap-2 text-sm cursor-pointer text-red-400 hover:bg-red-500/10'
                                            > 
                                            <Trash2 className='w-4 h-4' /> Delete
                                            </button> */}
                                            <button
                                                onClick={()=>{handleDeleteClick(newsletter.id)}}
                                                className="flex items-center justify-center gap-2 px-3 py-1.5 text-sm cursor-pointer
                                                            text-red-600 bg-red-500/10 hover:bg-red-500/20 rounded-md"
                                                >
                                                    <Trash2 className="w-4 h-4" />
                                                    <span>Delete</span>
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={5} className="px-6 py-12 text-center text-slate-400">
                                        {searchTerm || statusFilter !== 'all'
                                            ? 'No newsletter match your search criteria.'
                                            : 'No newsletter found.'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {pagination.totalPages > 1 && (
                        <div className="px-6 py-4 border-t border-white/10">
                            <CustomPagination
                                currentPage={page}
                                totalItems={pagination.total}
                                itemsPerPage={limit}
                                totalPages={pagination.totalPages}
                                onPageChange={handlePageChange}
                                onItemsPerPageChange={handleItemsPerPageChange}
                                itemsPerPageOptions={[5, 10, 25, 50]}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* <Modal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    resetForm();
                }}
                title={currentShow ? 'Edit Show' : 'Add New Show'}
            >
                <ShowForm
                    initialData={currentShow}
                    onSuccess={onSuccess}
                    onCancel={() => {
                        setIsModalOpen(false);
                        resetForm();
                    }}
                />
            </Modal> */}


            {/* <ShowDetails
                isOpen={!!currentShow && !isModalOpen}
                onClose={handleCloseViewModal}
                show={currentShow}
                onDelete={() => handleDeleteClick(currentShow?.id as string)}
                onEdit={()=> setIsModalOpen(true)}
            /> */}

            <ConfirmModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmDelete}
                title="Delete Show"
                message="Are you sure you want to delete this newsletter subscription? This action cannot be undone."
                confirmText="Delete"
                cancelText="Cancel"
            />
        </div>
    );
}